import * as PIXI from "pixi.js-legacy"

export default class ResourceManager {

	constructor(textManager, base64DataByHref) {
		this._textManager = textManager
		this._base64DataByHref = base64DataByHref

		// Prepare the PIXI loader
		this._pixiLoader = PIXI.Loader.shared
		this._pixiLoader.reset()

		this._totalNbOfResourcesToLoad = 0

		this._displayLoadingText(0)
	}

	_displayLoadingText(loadPercent) {
		this._loadPercent = loadPercent
		this._textManager.showMessage({ type: "loading", text: loadPercent })
	}

	addResource(resourceData) {
		if (!resourceData) {
			return
		}
		const {
			href, path, resourceType, fallbackHref, fallbackPath,
		} = resourceData

		switch (resourceType) {
		case "image":
			this._addToLoader(path, href)
			break
		case "video": // Do not load videos but only fallback images (if specified)
			this._addToLoader(fallbackPath, fallbackHref)
			break
		default:
			break
		}
	}

	_addToLoader(path, href) {
		// If no path or if the resource file path is already in the loader, skip it
		if (!path || PIXI.Loader.shared.resources[path]) {
			return
		}
		// Otherwise add it to the resources to load (with the correct path OR base64DataByHref)
		if (this._base64DataByHref) {
			this._pixiLoader.add(path, this._base64DataByHref[href])
		} else {
			this._pixiLoader.add(path, path)
		}
		this._totalNbOfResourcesToLoad += 1
	}

	loadAllResources() {
		return new Promise((resolve, reject) => {
			if (this._totalNbOfResourcesToLoad === 0) {
				this._loadPercent = null
				const error = new Error("No files to load")
				reject(error)
			}

			this._remainingNbOfResourcesToLoad = this._totalNbOfResourcesToLoad

			this._pixiLoader.load()

			// For each new resource loaded by PIXI, update the message displayed to the user
			this._pixiLoader.onProgress.add(() => {
				this._acknowledgeResourceHandling()
			})

			// If loading a resource yields an error, move on anyway
			this._pixiLoader.onError.add(() => {
				this._acknowledgeResourceHandling()
			})

			// When the PIXI loader has finished loading all resources, move on
			this._pixiLoader.onComplete.add(() => {
				this._loadPercent = null
				resolve()
			})

		})
	}

	_acknowledgeResourceHandling() {
		this._remainingNbOfResourcesToLoad -= 1
		let percent = (this._totalNbOfResourcesToLoad - this._remainingNbOfResourcesToLoad)
		percent /= this._totalNbOfResourcesToLoad
		const loadPercent = Math.round(100 * percent)
		this._displayLoadingText(loadPercent)
	}

	destroy() {
		this._pixiLoader.reset()

		// Clean PIXI texture cache
		const textureCache = PIXI.utils.TextureCache
		if (textureCache) {
			Object.values(textureCache).forEach((texture) => {
				const shouldDestroyBaseTexture = true
				texture.destroy(shouldDestroyBaseTexture)
			})
		}
	}

}